/**
 * This class updates the context in response to:
 * <ol>
 *     <li>Document selection events</li>
 *     <li>Document close events</li>
 *     <li>Active context changes within a document</li>
 *     <li>Active context changes at the UIContainer level<li>
 *     <li>Panel selection events</li>
 * </ol>
 */
define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "dojo/dom",
    "MW/layout/LayoutContainerEvent",
    "MW/layout/SelectionManager",
    "MW/uiframework/uicontainer/ChildProperties"
], function (declare, lang, dom, LayoutContainerEvent, SelectionManager, ChildProperties) {

    /**
     * @class
     */
    return declare(null, {

        constructor: function (appId, uiContainer) {
            var that = this;
            this._appId = appId;
            this._contextManager = uiContainer._contextManager;
            this._uiContainer = uiContainer;
            uiContainer.watch("selectedChild", function (name, oldValue, newValue) {
                that._updateSecondaryContext(newValue, uiContainer.get("activeContexts"));
            });
            uiContainer.watch("activeContexts", function (name, oldValue, newValue) {
                that._updateSecondaryContext(uiContainer.get("selectedChild"), newValue);
            });
            uiContainer.watch('lastSelectedDocument', function (name, oldValue, newValue) {
                if (newValue) {
                    var properties = uiContainer.getChildProperties(newValue);
                    that._setContext(properties);
                } else {
                    that._clearContext();
                }
            });
            if (!uiContainer._started) {
                uiContainer.on("started", function () {
                    if (that._pendingContext) {
                        this._contextManager.set("currentContext", that._pendingContext);
                        delete that._pendingContext;
                    }
                    if (that._pendingSecondaryContext) {
                        that._contextManager.set("secondaryContext", that._pendingSecondaryContext);
                        delete that._pendingSecondaryContext;
                    }
                });
                // g2103043: Explicitly set the secondary context to populate the pending secondary contexts
                this._updateSecondaryContext(uiContainer.get("selectedChild"), uiContainer.get("activeContexts"));
            }
        },

        setDocumentContainer: function (documentContainer) {
            var that = this;
            if (documentContainer !== this._documentContainer) {
                if (documentContainer) {
                    documentContainer.on(LayoutContainerEvent.CHILD_ADDED, function (widget, properties) {
                        if (!that._documentContainer || that._documentContainer.getDocumentCount(properties.documentType) === 1) {
                            // This is the first document of its type, forget any past selected tab
                            that._contextManager.resetLastSelectedTab({appId: properties.documentType});
                        }
                        // Watch for document internal context changes
                        properties.contextDriverContextWatch = properties.watch(ChildProperties.ACTIVE_CONTEXTS, function (name, oldValue, newValue) {
                            if (properties.get(ChildProperties.IS_SELECTED)) {
                                that._setContext(properties, newValue);
                            }
                        });
                    });
                    documentContainer.on(LayoutContainerEvent.CHILD_REMOVED, function (removedChild, properties) {
                        if (properties) {
                            properties.contextDriverContextWatch.unwatch();
                        }
                    });
                }
                this._documentContainer = documentContainer;
            }
        },

        _setContext: function (properties, contextIdList) {
            var context = {
                appId: properties.documentType,
                contextIdList: contextIdList || properties.get(ChildProperties.ACTIVE_CONTEXTS)
            };
            if (this._uiContainer._started) {
                this._contextManager.set("currentContext", context);
            } else {
                this._pendingContext = context;
            }
        },

        // Sets the current context to the global context.
        _clearContext: function () {
            if (this._uiContainer._started) {
                this._contextManager.set("currentContext", {appId: this._appId});
            }
        },

        _updateSecondaryContext: function(selectedChild, activeContexts) {
            var contexts = [];
            if (selectedChild) {
                var properties = this._uiContainer.getChildProperties(selectedChild);
                if (properties && properties.panelId) {
                    contexts.push(properties.panelId);
                }
            }
            if (activeContexts) {
                contexts = contexts.concat(activeContexts);
            }
            var context = {appId: this._appId, contextIdList: contexts};
            if (this._uiContainer._started) {
                this._contextManager.set("secondaryContext", context);
            } else {
                this._pendingSecondaryContext = context;
            }
        }
    });
});